<template>
    <div class="wrapper">
        <div class="page-header page-header-small">
            <parallax class="page-header-image"
                 style="background-image: url('img/bg32.jpg')">
            </parallax>
            <div class="content-center">
                <div class="row">
                    <div class="col-md-8 ml-auto mr-auto">
                        <h1 class="title">Join Us</h1>
                    </div>
                </div>
            </div>
        </div>
        <div class="section">
            <div class="about-contact">
                <div class="container">
                    <div class="row">
                        <div class="col-md-8 mr-auto ml-auto">
                            <h2 class="text-center title">Want to work at a rapid growing company?</h2>
                          
                                            <div class="section section-frequently">
                <div class="container">
                    <div class="text-center">
                        <h3 class="title">We are looking for talents below</h3>
                    </div>
                  <div class="text-center">
                      <h4 >Customer Service</h4>
                      </div>
                        <div class="text-center">
                           <h4 >IT Developer</h4>
                       </div>
                        <div class="text-center">
                           <h4 > send your resume to Cs@pagarstar.net</h4>
                       </div>
                       
                </div>
            </div>
                           
                        </div>
                        
                    </div>
                </div>
            </div>
    </div>
    </div> 
</template>
<script>
  import { Card, Button, Badge, InfoSection, FormGroupInput, Checkbox } from '@/components';
  import { Select, Option } from 'element-ui'

  export default {
    name: 'about-us',
    bodyClass: 'about-us',
    components: {
      Card,
      InfoSection,
      Badge,
      [Button.name]: Button,
      [Checkbox.name]: Checkbox,
      [FormGroupInput.name]: FormGroupInput,
      [Select.name]: Select,
      [Option.name]: Option,
    },
    data() {
      return {
        form: {
          firstName: '',
          email: '',
          speciality: ''
        }
      }
    }
  }
</script>
<style>
</style>
